<template>
    <div class="tab-mission-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="tab-mission-image">
                    <img src="../../assets/img/trustami/idea.svg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light">{{ $t("lang.request") }}</h4>
                    <p class="dec mt-10 mb-10 pre">
                        {"text": "Meine Großmutter hat uns immer die leckersten Butterbrote geschmiert!"}
                    </p>

                    <h4 class="font-weight--light">{{ $t("lang.response") }}</h4>
                    <p class="dec mt-10 pre">
                        {"lang": "de"}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentThree'
}
</script>
